/**
 * SysOps panel guided tour (Bill 2026-10-07 role walkthroughs). Live
 * surfaces only; nothing is verified, executed or exported for the person.
 * Bump `version` when the steps change.
 */
import type { TourDef } from '@retail-ops/guided-tour';

export const TOURS: ReadonlyArray<TourDef> = [
  {
    id: 'sysops-panel',
    version: 1,
    title: 'SysOps panel',
    summary: 'Operational health, the kill list, incidents and audit',
    roles: ['SystemOps', 'SuperAdmin'],
    steps: [
      {
        route: '/',
        title: 'The SysOps panel',
        body: <p>Operational health for Retail Operations: mark kill-list status, triage pipeline errors, replay failed notifications, and audit destructive actions.</p>,
      },
      {
        target: 'sysops-counts',
        title: 'At a glance',
        body: <p>Today&rsquo;s counts. Red and amber mean something is waiting on you.</p>,
      },
      {
        target: 'sysops-tiles',
        title: 'Where the work is',
        body: <p>Each tile opens one queue or log - the kill list, incidents, audit, and the operator-identity queues.</p>,
      },
      {
        target: 'kill-toolbar',
        route: '/kill-list',
        title: 'The kill list',
        body: <p>Two steps: <strong>verify</strong>, then <strong>execute</strong>. Filter by status and entry type here; tick rows to act on several at once.</p>,
      },
      {
        target: 'incidents-subnav',
        route: '/incidents/pipeline-errors',
        title: 'Incidents',
        body: <p>Applications that hit a pipeline error, notifications that failed to send, and signature requests that are stuck. Every table can be filtered and exported to CSV.</p>,
      },
      {
        target: 'audit-subnav',
        route: '/audit/purge-history',
        title: 'Audit',
        body: <p>Read-only history of purges, Test mode activity and notifications sent. Exportable to CSV.</p>,
      },
      {
        target: 'report-problem',
        title: 'Report a problem or suggest a change',
        body: <p>The lifebuoy, bottom-left. A picture of the screen and the recent activity go with your report.</p>,
      },
      {
        target: 'tour-start',
        route: '/',
        title: 'Take it again',
        body: <p><strong>Guided tour</strong> in the top bar runs this walkthrough again.</p>,
      },
    ],
  },
];
